import FallIntakeImage from "../../../assets/intake/fall.png";
import SpringIntakeImage from "../../../assets/intake/spring.png";
import SummerIntakeImage from "../../../assets/intake/summer.png";

export const Intake = [
  {
    intakeImg: FallIntakeImage,
    intakeName: "Fall Intake",
    date: "September",
    intakeSubtext:
      "The Fall intake is the most popular, offering the widest range of courses and programs. Deadlines typically fall between December and March of the previous year.",
  },
  {
    intakeImg: SpringIntakeImage,
    intakeName: "Spring Intake",
    date: "January",
    intakeSubtext:
      "The Fall intake is the most popular, offering the widest range of courses and programs. Deadlines typically fall between December and March of the previous year.",
  },
  {
    intakeImg: SummerIntakeImage,
    intakeName: "Summer Intake",
    date: "May",
    intakeSubtext:
      "The Fall intake is the most popular, offering the widest range of courses and programs. Deadlines typically fall between December and March of the previous year.",
  },
];
